<template>
    <div class="imagetext">
        <div class="tableTop">
            <div class="operationButton">
                <el-button
                    type="primary"
                    size="small"
                    @click="advertiseUpdate()"
                    >添加客户阶段</el-button
                >
            </div>
        </div>
        <section>
            <el-table :data="tabList" border stripe v-loading="isLoading">
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column
                    prop="id"
                    label="id"
                    v-if="false"
                ></el-table-column>
                <el-table-column
                    prop="title"
                    label="阶段名称"
                ></el-table-column>

                <el-table-column
                    prop="intro"
                    label="阶段描述"
                ></el-table-column>

                <el-table-column
                    prop="sort"
                    label="排序"
                    align="center"
                    width="120px"
                    v-if="false"
                ></el-table-column>
                <el-table-column label="操作" align="center" width="300px">
                    <div slot-scope="scope" class="operation">
                        <div>
                            <el-button
                                size="small"
                                type="text"
                                icon="el-icon-upload2"
                                @click="groupSorts(scope.row.id, 'up')"
                                :disabled="scope.$index?false:true,"
                                >上移</el-button
                            >
                        </div>
                        <div>
                            <el-button
                                size="small"
                                type="text"
                                icon="el-icon-download"
                                @click="groupSorts(scope.row.id, 'down')"
                                :disabled="
                                    scope.$index == tabList.length - 1
                                        ? true
                                        : false
                                "
                                >下移</el-button
                            >
                        </div>
                        <div class="view" @click="advertiseUpdate(scope.row)">
                            更新
                        </div>
                        <div
                            class="danger"
                            @click="advertiseDelete(scope.row.id)"
                        >
                            删除
                        </div>
                    </div>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="tablePage">
                <el-pagination
                    hide-on-single-page
                    background
                    @size-change="sizePage"
                    :current-page.sync="search.page"
                    :page-size="search.limit"
                    :total="search.total"
                    :page-sizes="[15, 20, 25]"
                    layout="total, sizes, prev, pager, next"
                ></el-pagination>
            </div>
            <!-- 信息更新-->
            <el-dialog
                title="信息更新"
                custom-class="listDialog"
                width="500px"
                :visible.sync="rightDialog"
                @close="$refs.leftTabForm.resetFields()"
            >
                <el-form
                    :model="rtRequestData"
                    ref="leftTabForm"
                    label-width="100px"
                    class="listForm"
                >
                    <el-form-item
                        label="阶段名称"
                        prop="title"
                        :rules="[
                            { required: true, message: '阶段名称不能为空' },
                        ]"
                    >
                        <el-input
                            v-model="rtRequestData.title"
                            placeholder="请输入阶段名称"
                        ></el-input>
                    </el-form-item>

                    <el-form-item prop="id" v-show="false">
                        <el-input v-model="rtRequestData.id"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="阶段描述"
                        prop="intro"
                        :rules="[
                            { required: true, message: '阶段描述不能为空' },
                        ]"
                    >
                        <el-input
                            type="textarea"
                            placeholder="请输入内容"
                            v-model="rtRequestData.intro"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort" v-show="false">
                        <el-input-number
                            v-model="rtRequestData.sort"
                            controls-position="right"
                            :min="0"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item label="流放到公海" prop="is_exile">
                        <el-radio :label="2" v-model="rtRequestData.is_exile"
                            >开启</el-radio
                        >
                        <el-radio :label="1" v-model="rtRequestData.is_exile"
                            >关闭</el-radio
                        >
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button
                        type="primary"
                        size="small"
                        @click="submitForm('leftTabForm')"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rtRequestData: {
                is_exile: 2,
                index: 0,
                id: '',
                title: '', //阶段名称名称
                intro: '', //描述
                sort: '',
            },
            rightDialog: false,
            isLoading: false,
            search: {
                total: 0,
                page: 1,
                limit: 15,
            },
            tabList: [],
        }
    },
    mounted() {
        this.getClientList()
    },
    watch: {
        'search.page'() {
            this.getClientList()
        },
        'search.limit'() {
            this.getClientList()
        },
    },
    methods: {
        sizePage(val) {
            this.search.limit = val
        },

        //排序

        groupSorts(id, sort) {
            let _self = this
            _self.$commonFun.debounce(async () => {
                let param = { id, type: sort }
                const res = await _self.$api.ImgDateSort(param)
                let index = _self.tabList.findIndex((item) => item.id == id)
                if (sort == 'up' && index) {
                    let item = _self.tabList.splice(index, 1)
                    _self.tabList.splice(index - 1, 0, item[0])
                }
                if (sort == 'down' && index !== _self.tabList.length - 1) {
                    let item = _self.tabList.splice(index, 1)
                    _self.tabList.splice(index + 1, 0, item[0])
                }
            })
        },
        async getClientList() {
            this.isLoading = true
            let param = {
                ...this.search,
            }
            const res = await this.$api.gitClientList(param)
            this.tabList = res
            this.isLoading = false
        },
        //删除
        async advertiseDelete(id) {
            await this.$confirm('确定删除该分组吗？此操作不可逆！', '提示')
            await this.$api.clientDel({ id })
            this.$commonFun.toast('删除成功', 'success')
            this.getClientList()
        },
        advertiseUpdate(item) {
            //更新

            this.rightDialog = true
            this.$nextTick(() => {
                if (item) {
                    this.rtRequestData.id = item.id
                    this.rtRequestData.title = item.title
                    this.rtRequestData.intro = item.intro
                    this.rtRequestData.sort = item.sort
                    this.rtRequestData.is_exile = item.is_exile
                }
            })
        },
        //更新
        submitForm(leftTabForm) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[leftTabForm].validate((valid) => {
                    if (valid) {
                        let param = _self.rtRequestData
                        _self.$api.imgClientUpdate(param).then((res) => {
                            _self.rightDialog = false
                            _self.$commonFun.toast('SUCCESS', 'success')
                            // if (param.id) _self.getImgList(_self.search.page)
                            // else { _self.getImgList() }
                            this.getClientList()
                        })
                    }
                })
            }, 500)
        },
    },
}
</script>

<style lang="scss">
.imagetext {
    .operation {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
}
</style>
